// extracted by mini-css-extract-plugin
export default {"container":"DialogFooterGroupItem--container--fab875","regular":"DialogFooterGroupItem--regular--d32ba4","critical":"DialogFooterGroupItem--critical--720b2e"};